<template>
  <div>
    <app-header title="" />

    <div class="container my-5">
      <h2>AI History.</h2>

      <div class="row mb-3">
        <div class="col-12 col-md-4">
          <input
            type="text"
            class="form-control"
            v-model="search"
            placeholder="Search titles..."
            @keyup.enter="reload"
          />
        </div>
      </div>

      <c-data-list ref="dataList" :items="conversations" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-4 col-xl-4">
            <p>Title</p>
          </div>
          <div class="col-6 col-lg-3 col-xl-3">
            <p>User</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Agent</p>
          </div>
          <div class="col-6 col-lg-1 col-xl-1">
            <p>Messages</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">
            <p>Updated</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <a-i-history-list-item :conversation="slotProps.item" />
        </template>
      </c-data-list>
    </div>
  </div>
</template>

<script>
import { http } from "utils";
import AIHistoryListItem from "./AIHistoryListItem";

export default {
  components: {
    AIHistoryListItem,
  },

  data: function () {
    return {
      conversations: [],
      search: "",
      page: 0,
      lastPage: 1,
    };
  },

  methods: {
    reload() {
      // Resetting the state re-arms the infinite scroll, which then loads
      // page one (with the current search) through loadNextPage.
      this.conversations = [];
      this.page = 0;
      this.lastPage = 1;
    },

    async loadNextPage(done) {
      try {
        if (this.page >= this.lastPage) {
          done(true);
          return;
        }

        const { data } = await http.get("ai/history", {
          params: { page: this.page + 1, search: this.search || undefined },
        });

        this.conversations = this.conversations.concat(data.data);
        this.page = data.meta.current_page;
        this.lastPage = data.meta.last_page;

        done(this.page >= this.lastPage);
      } catch (error) {
        done(true);
      }
    },
  },
};
</script>
